import React from 'react';
import { CheckCircle, Circle } from 'lucide-react';

// A big, tappable "radio card" row — used for single-select questions inside
// a slide-form step (e.g. journey type, PCI range, sign up vs log in) so each
// screen stays thumb-friendly and full-width.
export default function SlideOptionRow({ selected, onClick, title, subtitle, testId }) {
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={onClick}
      className={`flex w-full items-center justify-between gap-3 rounded-xl border p-4 text-left transition-colors ${
        selected ? 'border-primary bg-primary/5' : 'border-border hover:bg-muted/40'
      }`}
    >
      <span>
        <span className="block text-sm font-semibold text-[#0F172A]">{title}</span>
        {subtitle && <span className="mt-0.5 block text-xs text-muted-foreground">{subtitle}</span>}
      </span>
      {selected ? (
        <CheckCircle className="h-5 w-5 flex-shrink-0 text-primary" />
      ) : (
        <Circle className="h-5 w-5 flex-shrink-0 text-muted-foreground/40" />
      )}
    </button>
  );
}
